import { TabStyles } from '@tableau/widgets';
import { NestedCSSProperties } from 'typestyle/lib/types';
import { cssClass } from '../../style';

const cssPrefix = 'UploadWorkbook';

export namespace UploadWorkbookStyles {

  export const dialogWidth = 700;

  export const contentContainer = cssClass(cssPrefix, 'contentContainer', {
    display: 'flex',
  });

  export const innerContentContainer = cssClass(cssPrefix, 'inner-content-container', {
    flex: '1',
    minWidth: 0 // To contain text inside
  });

  export const workbookDetailsContainer = cssClass(cssPrefix, 'workbook-details-container', {
    $nest: {
      '& > * + *': {
        marginTop: '16px'
      }
    }
  });

  export const divider = cssClass(cssPrefix, 'vertical-divider', {
    width: 1,
    margin: '0 16px',
    backgroundColor: TabStyles.Colors.L3
  });

  export const footer = cssClass(cssPrefix, 'footer', {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '24px',
    $nest: {
      '& > * + *': {
        marginLeft: TabStyles.Spacing.MediumSpace
      }
    }
  });

  export const handleFlexOverflow: NestedCSSProperties = {
    textAlign: 'center',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    minWidth: 0,
    width: '100%'
  };

  export const textField = cssClass(cssPrefix, 'text-field', {
    width: '100%',
    $nest: {
      '& input': {
        width: '100%'
      }
    }
  });

  export const projectDropdown = cssClass(cssPrefix, 'project-dropdown', {
    $nest: {
      '& button': {
        justifyContent: 'flex-end'
      },

      // Targets arrow image
      '& button img': {
        margin: '0 !important'  // Need to override element style
      },

      '& button span': {
        ...handleFlexOverflow
      }
    }
  });

  export const projectExplorerPopup = cssClass(cssPrefix, 'project-explorer-popup', {
    height: '195px',
    scrollbarWidth: 'thin',
    $nest: {
      '& > div': {
        border: '1px solid #eee',
      },
      '& > div > div': {
        // Adding the border above creates a 1px horizontal scroll.
        // Brittle, but this prevents the scroll bar from appearing on windows by default
        overflowX: 'hidden !important' as 'hidden'
      }
    }
  });

  export const uploadWorkbookFileLimitDescription = cssClass(cssPrefix, 'upload-workbook-description', {
    color: TabStyles.Typography.Color.PrimaryLight,
    lineHeight: `${TabStyles.Typography.Sizing.XLarge}px`
  });

  export const descriptionField = cssClass(cssPrefix, 'description-field', {
    $nest: {
      '& textarea': {
        resize: 'vertical',
        minHeight: '50px'
      }
    }
  });

  export const sheetsContainer = cssClass(cssPrefix, 'sheets-container', {
    marginBottom: '16px'
  });

  export const sheetsLabel = cssClass(cssPrefix, 'sheets-label', {
    marginBottom: '8px'
  });

  /**
   * Drag and Drop Styles
   */
  export const dragAndDropContainer = cssClass(cssPrefix, 'file-container', {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '150px',
    marginBottom: '8px'
  });

  export const dragAndDropChildren = cssClass(cssPrefix, 'inner-container', {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    zIndex: 1, // Elevate children above ::after
  });

  export const defaultOutline = cssClass(cssPrefix, 'default-outline', {
    border: '2px dashed #ccc',
    position: 'relative',
    $nest: {
      '&::after': {
        content: '""',
        position: 'absolute',
        left: '-1px',
        top: '-1px',
        right: '-1px',
        bottom: '-1px',
        border: '1px solid #fff'
      }
    }
  });

  export const focusOutline = cssClass(cssPrefix, 'focus-outline', {
    backgroundColor: 'transparent',
    border: `2px solid ${TabStyles.Colors.Focus}`,
    boxShadow: `0 0 4px 0 ${TabStyles.Colors.Focus}`,
    outline: 'none'
  });

  export const activeOutline = cssClass(cssPrefix, 'active-outline', {
    border: `1px solid ${TabStyles.Colors.F5}`,
  });

  export const fileName = cssClass(cssPrefix, 'file-name', {
    color: TabStyles.Typography.Color.PrimaryMedium,
    marginTop: 0,
    marginBottom: '30px',
    ...handleFlexOverflow
  });

  export const dragAndDropText = cssClass(cssPrefix, 'drag-drop', {
    margin: 0,
    fontSize: '15px'
  });

  export const dragAndDropOrText = cssClass(cssPrefix, 'or', {
    margin: '8px 0',
    fontSize: '13px'
  });
}
